import { cn } from "@/utils/classes";

const PageWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn("bg-grayscale-xx-light w-[calc(100vw_-_210px)]", className)}
    >
      {children}
    </div>
  );
};

export default PageWrapper;
